import React, { useState, useEffect, useRef } from "react";
import styles from "./PatientProfilePage.module.css";
import VaccinationTrackerView from "./VaccinationTrackerView";
import TdscViewer from "./TdscViewer";
import GrowthChartDoctor from "./GrowthChartDoctorView";
import MchatView from "./MchatView";
import { calculateAgeInMonths } from "../helper/getAge";
import ParentMilstoneView from "./ParentMilestoneView";
import "./ParentProfile.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import PastVisitRecordDoctorView from "./PastVisitRecordDoctorView";
import dayjs from "dayjs";
import capitailzer from "../util/capitalize";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "./Loader";
import { pfdContents } from "../helper/getAgeGroup";
import PdfViewer from "./PdfViewer";
// import { useParentContext } from "../context/ParentContext";
// import RequireDoctorPopUp from "./ui/RequireDoctorPopUp";
import ConnectToDoctorPopUp from "./ui/ConnectToDoctorPopUp";
import { useParentContext } from "../context/ParentContext";
import TdscChartNew from "../components-4-6/TdscChart";
import ParentConsentPopup from "./ParentConsentPopup";
import axios from "axios";
import ChildProviderConsentModal from "./ui/ChildProviderConsentModal";

const ParentProfile = ({
  currentUser,
  setCurrentUser,
  handleUpdateProfile,
}) => {
  const healthDataRef = useRef(null);
  const updateProfileRef = useRef(null);
  const [selectedChild, setSelectedChild] = useState(null);
  const [selectedHealthData, setSelectedHealthData] = useState("");
  const [childId, setChildId] = useState("");
  const [loading, setLoading] = useState(false);
  const [addChildloading, setaddChildloading] = useState(false);
  const [formattedSummary, setFormattedSummary] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [formData, setFormData] = useState({
    phoneNumber: currentUser.parent_phone_number || "",
    email: currentUser.parent_email || "",
    firstName: "",
    lastName: "",
    relationship: currentUser.relationship || "",
    address: currentUser.address || "",
    childFirstName: currentUser.child_first_name || "",
    childLastName: currentUser.child_last_name || "",
    childGender: currentUser.child_gender || "",
    childDob: currentUser.child_dob ? currentUser.child_dob.split("T")[0] : "",
    childBirthWeight: currentUser.child_birth_weight || "",
    childBirthHeight: currentUser.child_birth_height || "",
    childGestationalAge: currentUser.child_gestational_age || "",
    childMedicalHistory: currentUser.child_medical_history || "",
    age: "", // For age dropdown
    childWeight: currentUser.child_weight || "",
    childHeight: currentUser.child_height || "",
    childHeadCircumference: currentUser.child_head_circumference || "",
    additionalNotes: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [id, setId] = useState("");
  const [docId, setDocId] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [changePasswordMode, setChangePasswordMode] = useState(false);
  const [error, setError] = useState("");
  const [chilAgeRange, setChilAgeRange] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [docInfo, setDocInfo] = useState(null);
  const [showChildProfilePopup, setShowChildProfilePopup] = useState(false); // New state for child profile pop-up
  const [ispatientFetched, setIsPatientFetched] = useState(false);
  const [newChildProfile, setNewChildProfile] = useState({
    // State for new child profile
    childFirstName: "",
    childLastName: "",
    childDob: "",
    childGender: "",
    childGestationalAge: "",
    childMedicalHistory: "",
    childAge: "",
    childWeight: "",
    childHeight: "",
    childHeadCircumference: "",
    childBirthWeight: "",
    childBirthHeight: "",
    additionalNotes: "",
  });
  const navigate = useNavigate();
  const token = localStorage.getItem("s2stoken");
  const {
    language,
    hasParentConsent,
    checkParentConsentStatus,
    childConsents,
    setParentState
  } = useParentContext();
  // const { parentState, setParentState } = useParentContext();
  // const [redFlags, setRedFlags] = useState([]);
  // const [showRedflagPopUp, setShowRedflagPopUp] = useState(false);
  const [connectToDoctorPopUp, setConnectToDoctorPopUp] = useState(false);
  const [showConsentPopup, setShowConsentPopup] = useState(false);
  const [showProviderConsentModal, setShowProviderConsentModal] =
    useState(false);
  const [consentLoading, setConsentLoading] = useState(false);
  const handleHealthDataChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedHealthData(selectedValue);
  };
  function handlePdfChange(content) {
    setPdfUrl(`/pdf/${chilAgeRange}/${content}.pdf`);
    setShowPdf(true);
  }
  function pdfClose() {
    setPdfUrl("");
    setShowPdf(false);
  }
  useEffect(() => {
    setSelectedHealthData("");
  }, [language]);

  useEffect(() => {
    if (currentUser?.parent_id && !hasParentConsent) {
      checkParentConsentStatus(currentUser.parent_id).then((isCompliant) => {
        if (!isCompliant) {
          setShowConsentPopup(true);
        }
      });
    }
  }, [currentUser?.parent_id, hasParentConsent]);

  const handleConsentSuccess = async (consentData) => {
    const payload = {
      parent_id: currentUser?.parent_id,
      required_consent_scope: consentData.required_consent_scope,
      optional_consent_scope: consentData.consentScope, // Array shape
      consent_form_version: consentData.consent_form_version,
      verification_request_id: consentData.transactionReceipt,
      age: consentData.age,
      consent_mechanism: "AADHAAR_OTP",
      aadhaar_number: consentData.aadhaar_number,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/submit_parent_compliance_record`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
        { withCredentials: true },
      );

      if (res.data?.success) {
        toast.success("Identity verification complete!");

        // Hide the popup
        setShowConsentPopup(false);

        // Instantly refresh and sync global states
        await checkParentConsentStatus(currentUser?.parent_id);
      } else {
        toast.error(res.data?.message || "Failed to submit compliance record.");
      }
    } catch (e) {
      console.error(e);
      toast.error("Error submitting compliance record.");
    }
  };

  const handleProceedProviderConsents = async (
    updatedChecks,
    applyAllChild,
  ) => {
    if (!childId || !currentUser?.parent_id) return;
    setConsentLoading(true);

    const childIdStr = String(childId);
    const activeChildScopes = childConsents[childIdStr] || [];
    const addedConsents = [];
    const revokedConsents = [];

    // Compute Delta
    Object.keys(updatedChecks).forEach((key) => {
      const wasChecked = activeChildScopes.includes(key);
      const isCheckedNow = !!updatedChecks[key];
      if (isCheckedNow && !wasChecked) {
        addedConsents.push(key);
      } else if (!isCheckedNow && wasChecked) {
        revokedConsents.push(key);
      }
    });

    try {
      // 1. Update the database
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/change_child_consents`,
        {
          childId: childId,
          addedConsents: addedConsents,
          revokedConsents: revokedConsents,
          applyAllChild: applyAllChild,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        },
      );

      if (response.data?.success) {
        // 2. Fetch confirmed state & sync
        await checkParentConsentStatus(currentUser.parent_id);

        // 3. Close the consent modal and open the target destination
        setShowProviderConsentModal(false);
        setConnectToDoctorPopUp(true);
      } else {
        throw new Error("Failed to update child consents.");
      }
    } catch (error) {
      console.error("Error writing child consent structures:", error);
      toast.error("Could not complete your consent request. Please try again.");
    } finally {
      setConsentLoading(false);
    }
  };

   console.log(childConsents,"childConsents");
   console.log(childId,"childId");
  const handleConnectToDoctorClick = () => {
    const activeConsents = childConsents[String(childId)] || [];
    console.log(activeConsents,"activeConsents");

    // Check if the current child has the specific required consent
    if (!activeConsents.includes("opt_provider_share")) {
      setShowProviderConsentModal(true); // Open Consent Modal First
    } else {
      setConnectToDoctorPopUp(true); // Skip straight to Connection
    }
  };
  const formateDate = (dateString) => {
    const dateParts = dateString.split(" ");
    const day = dateParts[0];
    const month =
      new Date(Date.parse(dateParts[1] + " 1, 2021")).getMonth() + 1; // Get month index (0-11)
    const year = dateParts[2];

    // Format month to two digits
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${year}-${formattedMonth}-${day}`;
  };

  const fetchPatientDetails = async (firstName, lastName, gender, dob) => {
    const payload = {
      firstName: firstName,
      lastName: lastName,
      gender: gender,
      dob: dob,
    };

    const fetchPatientUrl = `${process.env.REACT_APP_BACKEND_URL}/api/get_child_patient_id`;
    const fetchPatientOption = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json", // Specify the content type
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    };
    setId(null);
    setDocId(null);
    setChilAgeRange("");
    setDocInfo(null);
    setIsPatientFetched(false);
    // ? Fetch Associated Patient as child here
    try {
      setLoading(true);
      const response = await fetch(fetchPatientUrl, fetchPatientOption);
      const data = await response.json();
      if (!response.ok || data.success === false) {
        if (data?.message === "Patient not found") {
          setFormattedSummary([
            <p>
              Ask your pediatrician to sign up at <b>www.smile2steps.com.</b>
            </p>,
            <p>
              Once they have signed up, you will be able to access comprehensive
              health records of your child.
            </p>,
          ]);
        }
        throw new Error(data.message || "Unknown API error");
      }
      if (response.ok) {
        console.log("patient table data", data?.data);
        const patientId = data.data.patient_id;
        const doctorId = data.data.created_by_doctor_id;
        const docInfo = data?.data?.doctor;
        setId(patientId);
        setDocId(doctorId);
        setDocInfo(docInfo);
        const childMaterialAge = data?.data?.share_docs
          ? data?.data?.age_group
          : "";
        console.log("childMaterialAge ", childMaterialAge);
        setChilAgeRange(childMaterialAge);
        const summaryArray =
          data?.data?.ai_health_summary
            ?.split("\n")
            .filter((line) => line.trim() !== "")
            .map((line, index) => {
              const shouldNotTranslate =
                line.trim().startsWith("Name") ||
                line.trim().startsWith("Patient Name");
              return (
                <p
                  key={index}
                  {...(shouldNotTranslate ? { translate: "no" } : {})}
                >
                  {line}
                </p>
              );
            }) || [];

        setFormattedSummary(
          summaryArray.length > 0
            ? summaryArray
            : [
                <p>
                  Ask your pediatrician to sign up at{" "}
                  <b>www.smile2steps.com.</b>
                </p>,
                <p>
                  Once they have signed up, you will be able to access
                  comprehensive health records of your child.
                </p>,
              ],
        );
      } else {
        setFormattedSummary([
          <p>
            Ask your pediatrician to sign up at <b> www.smile2steps.com.</b>
          </p>,
          <p>
            Once they have signed up, you will be able to access comprehensive
            health records of your child.
          </p>,
        ]);
      }
    } catch (error) {
      setLoading(false);
      if (error?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
      console.log("error in fetching doctor data", error);
    } finally {
      setLoading(false);
      setIsPatientFetched(true);
    }
  };

  useEffect(() => {
    if (
      currentUser &&
      selectedChild !== null &&
      currentUser.children &&
      currentUser.children.length > 0
    ) {
      const childData = currentUser.children[selectedChild];

      if (childData) {
        setChildId(childData.child_id);
      }

      if (childData) {
        // Get the most recent growth history entry (assuming it's sorted)
        const latestGrowth =
          childData.growth_history && childData.growth_history.length > 0
            ? childData.growth_history[0] // Most recent growth entry
            : {};
        setFormData({
          phoneNumber: currentUser.parent_phone_number || "",
          email: currentUser.parent_email || "",
          firstName: currentUser.parent_first_name || "",
          lastName: currentUser.parent_last_name || "",
          relationship: currentUser.relationship || "",
          address: currentUser.address || "",
          childFirstName: childData.child_first_name || "",
          childLastName: childData.child_last_name || "",
          childGender: childData.child_gender || "",
          childDob: childData.child_dob
            ? childData.child_dob.split("T")[0]
            : "",
          childBirthWeight: childData.child_birth_weight || "",
          childBirthHeight: childData.child_birth_height || "",
          childGestationalAge: childData.child_gestational_age || "",
          childMedicalHistory: childData.child_medical_history || "",
          age: latestGrowth.child_age || "",
          childWeight: latestGrowth.child_weight || "",
          childHeight: latestGrowth.child_height || "",
          childHeadCircumference: latestGrowth.child_head_circumference || "",
          additionalNotes: latestGrowth.additional_notes || "",
          newPassword: "",
          confirmNewPassword: "",
        });
        fetchPatientDetails(
          childData.child_first_name,
          childData.child_last_name,
          childData.child_gender,
          formateDate(childData.child_dob),
        );
      } else {
        setFormData({
          phoneNumber: currentUser?.parent_phone_number || "",
          email: currentUser?.parent_email || "",
          firstName: currentUser?.parent_first_name || "",
          lastName: currentUser?.parent_last_name || "",
          relationship: currentUser?.relationship || "",
          address: currentUser?.address || "",
          childFirstName: "",
          childLastName: "",
          childGender: "",
          childDob: "",
          childBirthWeight: "", // New field
          childBirthHeight: "", // New field
          childGestationalAge: "", // New field
          childMedicalHistory: "", // New field
          age: "",
          childWeight: "",
          childHeight: "",
          childHeadCircumference: "",
          additionalNotes: "",
          newPassword: "",
          confirmNewPassword: "",
        });
      }
    }
  }, [currentUser, selectedChild]);

  function renderTdsc() {
    if (formData.childDob) {
      const currentAge = calculateAgeInMonths(formData.childDob);
      if (currentAge <= 36) {
        return (
          <TdscViewer
            patientId={id}
            pediatricianId={docId}
            currentAge={currentAge}
          />
        );
      } else {
        return (
          <TdscChartNew
            patientId={id}
            pediatricianId={docId}
            currentAge={currentAge}
          />
        );
      }
    }
  }

  useEffect(() => {
    if (selectedHealthData && healthDataRef.current) {
      healthDataRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    if (editMode && updateProfileRef.current) {
      updateProfileRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setTimeout(() => {
        updateProfileRef.current.focus();
      }, 500);
    }
  }, [selectedHealthData, editMode]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "childDob") {
      const dateParts = value.split("-");
      if (dateParts[0].length > 4) {
        dateParts[0] = dateParts[0].slice(0, 4);
      }
      setFormData({ ...formData, [name]: dateParts.join("-") });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleChildChange = (e) => {
    // setShowRedflagPopUp(false);
    if (e.target.value === "") {
      setId(null);
      setDocId(null);
      setChildId(null);
    }
    setSelectedHealthData("");
    const index = parseInt(e.target.value, 10);
    setSelectedChild(
      index >= 0 && index < (currentUser.children || []).length ? index : null,
    );
  };
  function handleChildDateChange(date) {
    if (!date) {
      setNewChildProfile({ ...newChildProfile, childDob: "" });
      return;
    }
    const formattedDate = dayjs(date).format("YYYY-MM-DD");
    setNewChildProfile({ ...newChildProfile, childDob: formattedDate });
  }

  const handleChildProfileChange = (e) => {
    const { name, value } = e.target;
    const cleaned = value.replace(/[^a-zA-Z0-9]/g, "");
    setNewChildProfile({ ...newChildProfile, [name]: cleaned });
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  const toggleChangePasswordMode = () => {
    setChangePasswordMode(!changePasswordMode);
    setFormData({
      ...formData,
      newPassword: "",
      confirmNewPassword: "",
    });
  };

  const toggleChildProfilePopup = () => {
    // Toggle the child profile pop-up
    setShowChildProfilePopup(!showChildProfilePopup);
    setNewChildProfile({
      childFirstName: "",
      childLastName: "",
      childDob: "",
      childBirthWeight: "",
      childBirthHeight: "",
      childGestationalAge: "",
      childMedicalHistory: "",
      childAge: "",
      childGender: "",
      childWeight: "",
      childHeight: "",
      childHeadCircumference: "",
      additionalNotes: "",
    });
  };

  const handleSubmit = async (e) => {
    console.log("clicked");
    e.preventDefault();

    if (changePasswordMode) {
      // Ensure both password fields are filled
      if (!formData.newPassword || !formData.confirmNewPassword) {
        setError("Both password fields are required.");
        setTimeout(() => setError(""), 3000);
        return;
      }

      // Check if passwords match
      if (formData.newPassword !== formData.confirmNewPassword) {
        setError("Passwords do not match.");
        setTimeout(() => setError(""), 3000);
        return;
      }

      // Enforce password policy
      const passwordRegex =
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,16}$/;
      if (!passwordRegex.test(formData.newPassword)) {
        setError(
          "Password must be 8-16 characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character.",
        );
        setTimeout(() => setError(""), 5000);
        return;
      }
    } else {
      // Ensure childFirstName and childLastName are filled
      if (!formData.childFirstName || !formData.childLastName) {
        setError("Child's first name and last name are required.");
        setTimeout(() => setError(""), 3000);
        return;
      }

      // Ensure childDob and childGender are filled if missing
      if (
        (!formData.childDob || !formData.childGender) &&
        (!currentUser.child_dob || !currentUser.child_gender)
      ) {
        setError("Child's date of birth and gender are required.");
        setTimeout(() => setError(""), 3000);
        return;
      }
    }

    const isFormEdited =
      formData.firstName !== currentUser.parent_first_name ||
      formData.lastName !== currentUser.parent_last_name ||
      (selectedChild !== null &&
        currentUser.children[selectedChild] &&
        (formData.childFirstName !==
          currentUser.children[selectedChild].child_first_name ||
          formData.childLastName !==
            currentUser.children[selectedChild].child_last_name ||
          formData.childGender !==
            currentUser.children[selectedChild].child_gender ||
          formData.childDob !== currentUser.children[selectedChild].child_dob ||
          formData.childBirthWeight !==
            currentUser.children[selectedChild].child_birth_weight ||
          formData.childBirthHeight !==
            currentUser.children[selectedChild].child_birth_height ||
          formData.childGestationalAge !==
            currentUser.children[selectedChild].child_gestational_age ||
          formData.childMedicalHistory !==
            currentUser.children[selectedChild].child_medical_history ||
          formData.age !== currentUser.children[selectedChild].child_age ||
          formData.childWeight !==
            currentUser.children[selectedChild].child_weight ||
          formData.childHeight !==
            currentUser.children[selectedChild].child_height ||
          formData.childHeadCircumference !==
            currentUser.children[selectedChild].child_head_circumference ||
          formData.additionalNotes !==
            currentUser.children[selectedChild].additional_notes));

    if (isFormEdited || (changePasswordMode && formData.newPassword)) {
      try {
        const response = await handleUpdateProfile(formData);
        if (response && response.success) {
          setCurrentUser(response.user);
        }
      } catch (error) {
        console.error("Failed to update profile:", error);
      } finally {
        setEditMode(false);
        setChangePasswordMode(false);
      }
    } else {
      setError(
        changePasswordMode ? "Passwords do not match." : "No changes made.",
      );
      setTimeout(() => setError(""), 3000);
    }
  };
  function handleMilestoneUpdate() {
    if (!childId) {
      setError("select-child");
      setTimeout(() => setError(""), 2500);
      return toast.warn("Please select child to proceed");
    }
    // if (docId && id) {
    navigate(`/update-milestonebyparent/${docId}/${id}/${childId}`);
    // }
    // navigate(`/updateMilestonebyparent/${childId}`);
  }
  function handleUploadMedia() {
    if (!childId) {
      setError("select-child");
      setTimeout(() => setError(""), 2500);
      return toast.warn("Please select child to proceed");
    }
    navigate(`/upload-media-by-parent/${docId}/${id}/${childId}`);
  }

const handleChildProfileSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !newChildProfile.childFirstName ||
      !newChildProfile.childLastName ||
      !newChildProfile.childGender ||
      !newChildProfile.childDob
    ) {
      toast.warn("All fields are required.");
      return;
    }

    try {
      setaddChildloading(true);
      
      // 1. First, wait for the child to actually be added to the database
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/add_child`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          credentials: "include",
          body: JSON.stringify({
            childFirstName: newChildProfile.childFirstName.toLowerCase().trim(),
            childLastName: newChildProfile.childLastName.toLowerCase().trim(),
            childDob: newChildProfile.childDob,
            childGender: newChildProfile.childGender,
          }),
        },
      );

      const result = await response.json();
      if (!response.ok || result.success === false) {
        throw new Error(result.message || "Failed to add child");
      }
      console.log(result);
      
      if (result.success) {
        // 2. Fire BOTH the profile fetch and the consent status check in PARALLEL
        const [profileResponse, consentStatusResult] = await Promise.all([
          fetch(
            `${process.env.REACT_APP_BACKEND_URL}/api/profile`,
            {
              method: "GET",
              credentials: "include",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
          checkParentConsentStatus(currentUser?.parent_id)
        ]);

        const updatedData = await profileResponse.json();
        console.log("Updated profile data:", updatedData);

        if (!profileResponse.ok || updatedData.success === false) {
          throw new Error(
            updatedData.message || "Failed to fetch updated profile",
          );
        }
        
        if (profileResponse.ok) {
          setParentState(updatedData.user)
          setCurrentUser(updatedData.user); // Update the currentUser state with the new child data
          // Set the newly added child as the selected child
          setSelectedChild(updatedData.user.children.length - 1);
        }
        toast.success("Child added successfully"); 
      }
    } catch (error) {
      toast.error(error?.message || "Failed to add Child");
      console.error("Error adding child", error);
      if (error?.message === "Token has expired") {
        localStorage.removeItem("s2stoken");
        navigate("/");
      }
    } finally {
      setaddChildloading(false);
      toggleChildProfilePopup();
    }
  };

  // useEffect(() => {
  //   function initiatePopup() {
  //     if (!childId) return;
  //     setShowRedflagPopUp(false);
  //     let redFlags = [];
  //     let redFlagChild = parentState?.children?.[selectedChild];
  //     const isPopUponed = redFlagChild?.showPopup ? true : false;
  //     if (redFlagChild.red_flags.length > 0) {
  //       redFlags = redFlagChild.red_flags.map((item) => item);
  //     }
  //     console.log(
  //       docId,
  //       isPopUponed,
  //       redFlags.length > 0,
  //       ispatientFetched,
  //       " redFlags"
  //     );
  //     setRedFlags(redFlags);
  //     if (!docId && !isPopUponed && redFlags.length > 0 && ispatientFetched) {
  //       setParentState((prevState) => ({
  //         ...prevState,
  //         children: prevState.children.map((child, index) => {
  //           if (index === selectedChild) {
  //             return {
  //               ...child,
  //               showPopup: true,
  //             };
  //           }
  //           return child;
  //         }),
  //       }));
  //       setShowRedflagPopUp(true);
  //     }
  //   }
  //   initiatePopup();
  // }, [ispatientFetched]);

  if (!currentUser) {
    return <p>Loading...</p>;
  }
  const CustomInput = ({ value, onClick }) => (
    <div className="date-picker-container" onClick={onClick}>
      <input
        type="text"
        defaultValue={value}
        placeholder="dd/mm/yyyy"
        readOnly
      />
      <FontAwesomeIcon icon={faCalendarAlt} className="calendar-icon" />
    </div>
  );

  return (
    <div className="child-profile-container">
      <div className="child-profile-innerContainer">
        {/* {showRedflagPopUp && (
          <RequireDoctorPopUp
            child={currentUser?.children[selectedChild]}
            redFlags={redFlags}
            setShowRedflagPopUp={setShowRedflagPopUp}
          />
        )}  */}
        {connectToDoctorPopUp && (
          <ConnectToDoctorPopUp
            setConnectToDoctorPopUp={setConnectToDoctorPopUp}
            childId={childId}
            parentId={currentUser.parent_id}
            dob={formData.childDob}
          />
        )}
        <ParentConsentPopup
          visible={showConsentPopup}
          forexistingParent={true}
          userPhoneNumber={currentUser?.parent_phone_number}
          onSuccess={handleConsentSuccess}
          onCancel={() => {}}
        />
        <ChildProviderConsentModal
          visible={showProviderConsentModal}
          currentConsents={childConsents[String(childId)] || []}
          haveMultichild={currentUser?.children?.length > 1}
          loading={consentLoading}
          onCancel={() => setShowProviderConsentModal(false)}
          onProceed={handleProceedProviderConsents}
        />
        <div className="child-header">
          {/* <img src={logo} alt="Logo" className="logo" /> */}
          <h2>Child Profile</h2>
        </div>
        {/* {successMessage && <p className="success-message">{successMessage}</p>}
        {error && <p className="error-message">{error}</p>} */}
        <form onSubmit={handleSubmit} noValidate>
          <div className="child-profile-wrapper">
            <div className="child-profile">
              <div>
                <label>Phone Number</label>
                <span className="notranslate" translate="no">
                  {capitailzer(currentUser.parent_phone_number)}
                </span>
              </div>
              <div>
                <label>Email:</label>
                <span className="notranslate" translate="no">
                  {currentUser.parent_email || "Not Available"}
                </span>
              </div>
              <div>
                <label>Parent First Name:</label>
                <span className="notranslate" translate="no">
                  {capitailzer(currentUser.parent_first_name)}
                </span>
              </div>
              <div>
                <label>Parent Last Name:</label>
                <span className="notranslate" translate="no">
                  {capitailzer(currentUser.parent_last_name)}
                </span>
              </div>
              <div>
                <label>Relationship to the child</label>
                <span className="notranslate" translate="no">
                  {capitailzer(currentUser.relationship)}
                </span>
              </div>
              <div>
                <label>Address</label>
                <span className="notranslate" translate="no">
                  {capitailzer(currentUser.address)}
                </span>
              </div>
            </div>
            <div className="child-options">
              {currentUser.children && currentUser.children.length > 0 && (
                <div>
                  <label>Select Child</label>
                  <select
                    className={`${
                      error === "select-child" ? "select-error" : ""
                    }`}
                    value={selectedChild}
                    onChange={handleChildChange}
                    required
                  >
                    <option value="">Select a Child</option>
                    {currentUser.children
                      .filter((child) => child) // Filter out undefined/null children
                      .map((child, index) => (
                        <option
                          className="notranslate"
                          translate="no"
                          key={index}
                          value={index}
                        >
                          {capitailzer(child.child_first_name)}{" "}
                          {capitailzer(child.child_last_name)}
                        </option>
                      ))}
                  </select>
                </div>
              )}
              <div className="media-div">
                {/* {!editMode &&
                  !changePasswordMode &&
                  currentUser.children &&
                  currentUser.children.length > 0 &&
                  selectedChild !== null &&
                  selectedChild !== "" && (
                    <button className="" type="button" onClick={toggleEditMode}>
                      Update Profile Details
                    </button>
                  )} */}
                <button
                  disabled={loading}
                  type="button"
                  onClick={handleMilestoneUpdate}
                >
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <p>Update Milestone Tracker</p>
                  )}
                </button>
                {/* <button type="button" onClick={handleUploadMedia} disabled={loading}>
                  {loading ? (
                    <p>Loading...</p>
                  ) : (
                    <p>Upload Video/Audio</p>
                  )}
                </button> */}
              </div>
              <div>
                {!editMode && !changePasswordMode && (
                  <button
                    className=""
                    type="button"
                    onClick={toggleChildProfilePopup}
                  >
                    Add Child
                  </button>
                )}
              </div>
            </div>
            {selectedChild !== null && (
              <>
                <div className="doc-info">
                  <p>Child Information</p>
                </div>
                <div className="child-profile">
                  <div>
                    <label>First Name</label>
                    <span className="notranslate" translate="no">
                      {capitailzer(formData.childFirstName) || "Not available"}
                    </span>
                  </div>
                  <div>
                    <label>Last Name</label>
                    <span className="notranslate" translate="no">
                      {capitailzer(formData.childLastName) || "Not available"}
                    </span>
                  </div>
                  <div>
                    <label>Date of Birth</label>
                    <span className="notranslate" translate="no">
                      {formData.childDob || "Not available"}
                    </span>
                  </div>
                  <div>
                    <label>Gender</label>
                    <span className="notranslate" translate="no">
                      {capitailzer(formData.childGender) || "Not available"}
                    </span>
                  </div>
                  {/* {childId && !docId && ispatientFetched &&<div>
                    <button className="connect-to-doc-btn">Connect to your doctor</button>
                  </div>} */}
                  {/* <div>
                  <label>Birth Weight (kg)</label>
                  <span>{formData.childBirthWeight || "Not available"}</span>
                </div>
                <div>
                  <label>Birth Height (cm)</label>
                  <span>{formData.childBirthHeight || "Not available"}</span>
                </div>
                <div>
                  <label>Gestational Age (weeks)</label>
                  <span>{formData.childGestationalAge || "Not available"}</span>
                </div>
                <div>
                  <label>Birth Medical History</label>
                  <span>{formData.childMedicalHistory || "Not available"}</span>
                </div>
                <div>
                  <label>Age (Months)</label>

                  {editMode ? (
                    <select
                      name="age"
                      value={formData.age}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Age</option>
                      <option value="0">At Birth</option>
                      {Array.from({ length: 36 }, (_, i) => i + 1).map(
                        (age) => (
                          <option key={age} value={age}>
                            {age} {age === 1 ? "Month" : "Months"}
                          </option>
                        )
                      )}
                    </select>
                  ) : (
                    <span>{formData.age || "Not available"}</span>
                  )}
                </div>
                <div>
                  <label>Weight (kg)</label>
                  {editMode ? (
                    <input
                      ref={updateProfileRef}
                      type="text"
                      name="childWeight"
                      value={formData.childWeight}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>{formData.childWeight || "Not available"}</span>
                  )}
                </div>
                <div>
                  <label>Height (cm)</label>

                  {editMode ? (
                    <input
                      type="text"
                      name="childHeight"
                      value={formData.childHeight}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>{formData.childHeight || "Not available"}</span>
                  )}
                </div>
                <div>
                  <label>Head Circumference (cm)</label>

                  {editMode ? (
                    <input
                      type="text"
                      name="childHeadCircumference"
                      value={formData.childHeadCircumference}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>
                      {formData.childHeadCircumference || "Not available"}
                    </span>
                  )}
                </div>
                <div>
                  <label>Additional Notes</label>

                  {editMode ? (
                    <input
                      type="text"
                      name="additionalNotes"
                      value={formData.additionalNotes}
                      onChange={handleChange}
                    />
                  ) : (
                    <span>{formData.additionalNotes || "Not available"}</span>
                  )}
                </div> */}
                </div>
              </>
            )}
            {selectedChild !== null && docInfo && (
              <>
                <div className="doc-info">
                  <p>Provider Information</p>
                </div>
                {loading ? (
                  <p style={{ textAlign: "center", fontSize: "18px" }}>
                    Loading...
                  </p>
                ) : (
                  <div className="child-profile">
                    <div>
                      <label>First Name</label>
                      <span className="notranslate" translate="no">
                        {capitailzer(docInfo?.pediatrician_first_name) ||
                          "Not available"}
                      </span>
                    </div>
                    <div>
                      <label>Last Name</label>
                      <span className="notranslate" translate="no">
                        {capitailzer(docInfo?.pediatrician_last_name) ||
                          "Not available"}
                      </span>
                    </div>
                    <div>
                      <label>Clinic Name</label>
                      <span className="notranslate" translate="no">
                        {docInfo?.pediatrician_clinic_name || "Not available"}
                      </span>
                    </div>
                    <div>
                      <label>Specialization</label>
                      <span className="notranslate" translate="no">
                        {capitailzer(docInfo?.pediatrician_specialization) ||
                          "Not available"}
                      </span>
                    </div>
                  </div>
                )}
              </>
            )}

            {/* {editMode && (
              <button className="change-profile-button" type="submit">
                Save Profile Changes
              </button>
            )}
            {editMode && (
              <button
                className="change-profile-button"
                type="button"
                onClick={toggleEditMode}
              >
                Cancel Profile Changes
              </button>
            )} */}
          </div>
        </form>
        {childId && !docId && ispatientFetched && (
          <div className="connect-to-doctor">
            <button
              onClick={handleConnectToDoctorClick}
              className="connect-to-doc-btn"
            >
              Connect to your doctor
            </button>
            <p>
              <span>◈</span> Ask your doctor their Doctor ID.
            </p>
          </div>
        )}
        {selectedChild !== null && docId && (
          <div className="doc-materials">
            <p>Educational Material Shared by Provider</p>
            {loading ? (
              <p>Loading...</p>
            ) : chilAgeRange && pfdContents[chilAgeRange] ? (
              <div className="pdf-container" style={{ marginTop: "20px" }}>
                {pfdContents[chilAgeRange].map((content, i) => (
                  <div key={i} className="child-pdf-button">
                    <p>{`${content}`}</p>
                    <button onClick={() => handlePdfChange(content)}>
                      Open PDF
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ fontSize: "18px", marginTop: "20px" }}>
                No Material Shared By Doctor
              </p>
            )}
            {showPdf && chilAgeRange && (
              <PdfViewer onClose={pdfClose} pdfUrl={pdfUrl} />
            )}
          </div>
        )}

        {/* Child Profile Popup */}
        {showChildProfilePopup && (
          <div className="child-profile-popup">
            <Loader isLoading={addChildloading} />
            <div className="popup-content">
              <span className="close-button" onClick={toggleChildProfilePopup}>
                &times;
              </span>
              <h3>Add Child</h3>
              <form onSubmit={handleChildProfileSubmit} noValidate>
                <div className="child-form-group">
                  <label>First Name:</label>
                  <input
                    type="text"
                    name="childFirstName"
                    value={newChildProfile.childFirstName}
                    onChange={handleChildProfileChange}
                    onPaste={(e) => e.preventDefault()}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Last Name:</label>
                  <input
                    type="text"
                    name="childLastName"
                    value={newChildProfile.childLastName}
                    onChange={handleChildProfileChange}
                    onPaste={(e) => e.preventDefault()}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Date of Birth:</label>
                  {/* <input
                    type="date"
                    name="childDob"
                    value={newChildProfile.childDob}
                    onChange={handleChildProfileChange}
                    max={new Date().toISOString().split("T")[0]} // This disables future dates
                    required
                  /> */}
                  <DatePicker
                    name="childDob"
                    className="child-date-picker"
                    selected={
                      newChildProfile.childDob
                        ? new Date(newChildProfile.childDob)
                        : null
                    }
                    onChange={handleChildDateChange}
                    dateFormat="dd/MM/yyyy"
                    maxDate={new Date()}
                    showYearDropdown
                    scrollableYearDropdown
                    portalId="root"
                    customInput={
                      <CustomInput
                        value={newChildProfile.childDob}
                        onClick={onclick}
                      />
                    }
                  />
                </div>
                <div className="child-form-group">
                  <label>Gender:</label>
                  <select
                    name="childGender"
                    value={newChildProfile.childGender}
                    onChange={handleChildProfileChange}
                    required
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                {/* <div className="child-form-group">
                  <label>Birth Weight (kg):</label>
                  <input
                    type="text"
                    name="childBirthWeight"
                    value={newChildProfile.childBirthWeight}
                    onChange={handleChildProfileChange}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Birth Height (cm):</label>
                  <input
                    type="text"
                    name="childBirthHeight"
                    value={newChildProfile.childBirthHeight}
                    onChange={handleChildProfileChange}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Gestational Age (weeks):</label>
                  <input
                    type="text"
                    name="childGestationalAge"
                    value={newChildProfile.childGestationalAge}
                    onChange={handleChildProfileChange}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Birth Medical History:</label>
                  <input
                    type="text"
                    name="childMedicalHistory"
                    value={newChildProfile.childMedicalHistory}
                    onChange={handleChildProfileChange}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Age (Months):</label>
                  <select
                    name="childAge"
                    value={newChildProfile.childAge}
                    onChange={handleChildProfileChange}
                    required
                  >
                    <option value="">Select Age</option>
                    <option value="0">At Birth</option>
                    {Array.from({ length: 36 }, (_, i) => i + 1).map(
                      (childAge) => (
                        <option key={childAge} value={childAge}>
                          {childAge} {childAge === 1 ? "Month" : "Months"}
                        </option>
                      )
                    )}
                  </select>
                </div>
                <div className="child-form-group">
                  <label>Weight (kg):</label>
                  <input
                    type="text"
                    name="childWeight"
                    value={newChildProfile.childWeight}
                    onChange={handleChildProfileChange}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Height (cm):</label>
                  <input
                    type="text"
                    name="childHeight"
                    value={newChildProfile.childHeight}
                    onChange={handleChildProfileChange}
                    required
                  />
                </div>
                <div className="child-form-group">
                  <label>Head Circumference (cm):</label>
                  <input
                    type="text"
                    name="childHeadCircumference"
                    value={newChildProfile.childHeadCircumference}
                    onChange={handleChildProfileChange}
                  />
                </div>
                <div className="child-form-group">
                  <label>Additional Notes:</label>
                  <input
                    type="text"
                    name="additionalNotes"
                    value={newChildProfile.additionalNotes}
                    onChange={handleChildProfileChange}
                  />
                </div> */}
                <div className="child2-center">
                  <button className="btn1" type="submit">
                    Save
                  </button>
                  <button
                    className="btn2"
                    type="button"
                    onClick={toggleChildProfilePopup}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {selectedChild !== null && (
          <section className={styles.profileSection}>
            <header>Child Health Summary</header>
            {loading ? <p>Loading...</p> : <div>{formattedSummary}</div>}
          </section>
        )}
        {changePasswordMode && (
          <form onSubmit={handleSubmit} className="change-password-container">
            <div className="child-form-group-passwords">
              <div style={{ position: "relative" }}>
                <TextField
                  size="small"
                  type={!isPasswordVisible ? "password" : "text"}
                  name="newPassword"
                  label="New Password"
                  value={formData.newPassword}
                  onChange={handleChange}
                />
                <FontAwesomeIcon
                  icon={isPasswordVisible ? faEyeSlash : faEye}
                  onClick={() => setIsPasswordVisible((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#555",
                  }}
                />
              </div>
              <div style={{ position: "relative" }}>
                <TextField
                  size="small"
                  type={!isConfirmPasswordVisible ? "password" : "text"}
                  name="confirmNewPassword"
                  label="Confirm new Password"
                  value={formData.confirmNewPassword}
                  onChange={handleChange}
                />
                <FontAwesomeIcon
                  icon={isConfirmPasswordVisible ? faEyeSlash : faEye}
                  onClick={() => setIsConfirmPasswordVisible((prev) => !prev)}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#555",
                  }}
                />
              </div>
            </div>
            <div className="change-password-btns">
              <button className="add-child-btn password-btn" type="submit">
                Save Password
              </button>
              <button
                className="change-profile-button password-btn"
                type="button"
                onClick={toggleChangePasswordMode}
              >
                Cancel Password Change
              </button>
            </div>
            {error && <p className="error-message">{error}</p>}
          </form>
        )}
        <div className="child-healthData">
          <div>
            <label htmlFor="healthData">View Health Data</label>
            <select
              id="healthData"
              value={selectedHealthData}
              onChange={handleHealthDataChange}
            >
              {childId ? (
                <>
                  <option value="">Select Data</option>
                  {docId && id && (
                    <option value="past_visit_records">
                      All Visit Records
                    </option>
                  )}
                  {docId && id && (
                    <option value="growth_charts">Growth Charts</option>
                  )}
                  {docId && id && (
                    <option value="immunizations">Vaccination Tracker</option>
                  )}
                  <option value="mtwredflags">
                    Milestone Tracker & Red Flags
                  </option>
                  {docId && id && <option value="tdscChart">TDSC Chart</option>}

                  {docId && id && <option value="mchat">MCHAT</option>}
                </>
              ) : (
                <option value="">Please select a child to proceed</option>
              )}
            </select>
          </div>
          <div>
            {!editMode && !changePasswordMode && (
              <button
                className="change-password-btn"
                type="button"
                onClick={toggleChangePasswordMode}
              >
                Change Password
              </button>
            )}
          </div>
        </div>

        {selectedHealthData && childId && (
          <div ref={healthDataRef} className={styles.healthDataContainer}>
            <div className={styles.healthDataContent}>
              {selectedHealthData === "mtwredflags" && (
                <ParentMilstoneView childId={childId} />
              )}
              {selectedHealthData === "immunizations" && (
                <VaccinationTrackerView patientId={id} pediatricianId={docId} />
              )}
              {selectedHealthData === "growth_charts" && (
                <GrowthChartDoctor childId={id} />
              )}
              {selectedHealthData === "tdscChart" && renderTdsc()}
              {selectedHealthData === "mchat" && (
                <MchatView id={id} docId={docId} />
              )}
              {selectedHealthData === "past_visit_records" && (
                <PastVisitRecordDoctorView
                  id={id}
                  docId={docId}
                  patientName={`${formData.childFirstName} ${formData.childLastName}`}
                  currentAge={calculateAgeInMonths(formData?.childDob)}
                  isparent={true}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentProfile;
